<div class="general-container h-full px-12 py-16 flex flex-col justify-between">
  <div *ngIf="loading">
    <fun-spinner></fun-spinner>
  </div>
  <div *ngIf="step === 'group_list' && !loading" class="md:max-h-[calc(100% - 100px)] overflow-auto">
    <div class="w-full py-32">
      <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">Grupos Prioritarios
      </h2>
      <p class="font-sans text-center text-gray-40 text-l pb-24">Estos son los grupos prioritarios de este
        proyecto, si puedes
        probar tu pertenencia a alguno de ellos,
        seleccionalo.</p>
    </div>

    <div class="flex flex-col relative items-center max-w-[620px] mx-auto">

      <!-- Timeline Groups Loop -->
      <div *ngFor="let group of groupedPriorityGroups; let isLast = last; let i = index"
        class="relative pb-16 last:pb-0 w-full">

        <!-- Priority Node & Items -->
        <div class="flex gap-10">

          <!-- Group Content -->
          <div class="flex flex-col gap-12 w-full">

            <!-- Individual Items within this Priority Group -->
            <div *ngFor="let pg of group.items" class="flex flex-col gap-6 px-16 py-24 cursor-pointer rounded-xl border"
              [ngClass]="{ 'border-2 border-orange-100 bg-sepa': pg.id === groupSelected?.id, 'border-eggplant-100/[0.25]': pg.id !== groupSelected?.id }"
              (click)="selectGroup(pg)">

              <!-- Item Main Header/Title -->
              <div class="flex flex-col gap-2">
                <div class="flex justify-between items-start gap-4">
                  <h3 class="text-xl font-sans text-eggplant-100 leading-tight">
                    {{ pg.name }}
                  </h3>

                </div>
                <p class="text-m font-sans text-eggplant-100 opacity-60 leading-relaxed">
                  {{ pg.description }}
                </p>
              </div>

              <!-- Codes/Values Accordion -->
              <div *ngIf="pg.value && pg.type !== 2" class="rounded-xl bg-gray-10/40 border border-gray-10 overflow-hidden">
                <!-- Accordion Header -->
                <div (click)="toggleExpand(pg.id, $event)"
                  class="flex items-center justify-between px-12 py-8 cursor-pointer hover:bg-gray-10/60 transition-colors duration-200">
                  <span class="text-s font-sans text-eggplant-100/[0.7]">Ver códigos ({{ parseValues(pg.value).length }})</span>
                  <fun-icon [name]="'chevron-down'"
                    [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100/[0.5] transition-transform duration-500 ' + (isExpanded(pg.id) ? 'rotate-180' : '')"></fun-icon>
                </div>
                <!-- Accordion Content -->
                <div *ngIf="isExpanded(pg.id)" class="px-12 pb-12 pt-4">
                  <div class="grid grid-cols-4 md:grid-cols-6 gap-6 justify-items-center">
                    <span *ngFor="let code of parseValues(pg.value)"
                      class="w-full text-center px-8 py-4 rounded-lg bg-white border border-eggplant-100/[0.1] text-s font-sans font-mono text-eggplant-100/[0.8]">
                      {{ code }}
                    </span>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>

  <div *ngIf="step === 'generic_validation' && !loading" class="py-72">
    <div class="w-full py-32 flex flex-col relative items-center max-w-[620px] mx-auto gap-32">
      <fun-icon [name]="'check-circle'" [style]="'w-48 h-48 stroke-[4px] stroke-orange-100'"></fun-icon>
      <h2 class="font-sans text-h600 md:text-h800 text-center bg-gradient-2-text linear-gradient-2">Validación
        en proceso
      </h2>
      <p class="font-sans text-center text-gray-40 text-l pb-24">Durante las próximas 72 horas procederemos a verificar
        que perteneces a este grupo prioritario. Durante el proceso de validación podremos contactar contigo para
        pedirte algún documento que lo demuestre.</p>
    </div>
  </div>
  <div *ngIf="step === 'group_list' && !loading"
    class="button-container flex py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row md:border-t md:border-eggplant-10 justify-between">
    <div class="prev">
      <fun-new-button size="xl" (eventClick)="prev()" icon="arrow-left" [iconPosition]="'left'" [buttonType]="backCta"
        title="{{ 'local_invest.go_back' | translate }}" [responsive]="false"></fun-new-button>
    </div>
    <div class="next">
      <fun-new-button size="xl" (eventClick)="next()" class="next-btn" [classExtra]="' !w-full '" [buttonType]="sendXHR"
        title="{{ 'AUTOINVEST.FOOTER.NEXT' | translate }}" [responsive]="false"></fun-new-button>
    </div>
  </div>
</div>